import { computed, ComputedRef, Ref } from 'vue';
import type { ArticleV1, BookV1, Content, MaterialV1, VideoV1 } from '@ilteducation/content-registry-types';

interface FilterMap {
  [type: string]: (item: Content, search: string) => boolean;
}

// Example filter functions for different content types
const filterMap: FilterMap = {
  BookV1: (item: Content, search: string) => (item as BookV1).title.toLowerCase().includes(search.toLowerCase()),
  VideoV1: (item: Content, search: string) =>
    Object.values((item as VideoV1).title).find((title) =>
      title.value?.toLowerCase().includes(search.toLowerCase()),
    ) !== undefined,
  ArticleV1: (item: Content, search: string) =>
    (item as ArticleV1).headline.toLowerCase().includes(search.toLowerCase()),
  MaterialV1: (item: Content, search: string) =>
    (item as MaterialV1).title.toLowerCase().includes(search.toLowerCase()),
};

const useCollectionInternalSearch = (search: Ref<string>, contents: ComputedRef<Content[]>) =>
  computed(() => {
    if (contents.value.length === 0) {
      return [] as Content[];
    }
    if (search.value === '') {
      return contents.value;
    }
    return contents.value.filter((item) => {
      const type = item.type;
      const filterFn = filterMap[type!] || (() => true); // Fallback to a no-op filter if type not found
      return filterFn(item, search.value);
    });
  });

export default useCollectionInternalSearch;
